import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function FirstSubjectIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3405">
      <div className="relative w-full h-full bg-gradient-to-br from-yellow-100 to-amber-300 overflow-hidden" data-id="element-3406">
        {/* Background: Rays */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3407">
          <g className="origin-center animate-[spin_30s_linear_infinite]" style={{
          transformOrigin: '100px 100px'
        }} data-id="element-3408">
            {[...Array(8)].map((_, i) => <path key={i} d="M100 100 L70 -20 L130 -20 Z" fill="#FDE047" fillOpacity="0.4" transform={`rotate(${i * 45} 100 100)`} data-id="element-3409" />)}
          </g>
          <circle cx="100" cy="100" r="60" fill="#FEF08A" fillOpacity="0.5" filter="blur(10px)" data-id="element-3410" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-3411">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-3412">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'celebrating' : 'encouraging'} variant={variant} accessory="starWand" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3413" />
          </div>
        </div>

        {/* Foreground: Giant Star behind Djay */}
        <svg className="absolute inset-0 w-full h-full z-0 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3414">
          <path d="M100 20 L120 70 L175 75 L135 110 L145 165 L100 135 L55 165 L65 110 L25 75 L80 70 Z" fill="#F59E0B" opacity="0.2" data-id="element-3415" />
        </svg>

        {/* Foreground: Small stars */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3416">
            <path d="M30 60 L33 70 L43 72 L35 78 L38 88 L30 82 L22 88 L25 78 L17 72 L27 70 Z" fill="#FDE047" data-id="element-3417" />
            <path d="M160 40 L162 46 L168 47 L163 51 L165 57 L160 53 L155 57 L157 51 L152 47 L158 46 Z" fill="#FDE047" data-id="element-3418" />
            <path d="M170 130 L171.5 136 L177.5 137 L173 141 L174.5 147 L170 144 L165.5 147 L167 141 L162.5 137 L168.5 136 Z" fill="#FDE047" data-id="element-3419" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}